import { Checkbox } from 'antd'

const LeftFloatingCheckbox = ({ checked, style, onChange }) => {
  return (
    <div className='absolute top-5 left-5' style={style}>
      <Checkbox checked={checked} onChange={onChange} />
    </div>
  )
}

export default LeftFloatingCheckbox
